import cx from 'classnames';
import { Location } from 'history';
import {
    CLOSE_STICKY_RECTANGLE,
} from 'mk/autogenerated/translations/AdSlotAnchorLeaderboard.1adf669c1fb74f9a9453089f6dcee513'
import { hasAds } from 'mk/bazaar/common/userUtils';
import { AdSlot } from 'mk2/containers/AdSlot/AdSlot';
import {
    adSlotAnchorLeaderboardCloseByUser,
} from 'mk2/containers/AdSlotAnchorLeaderboard/AdSlotAnchorLeaderboard.actions';
import { getAdSlotAnchorLeaderboardState } from 'mk2/containers/AdSlotAnchorLeaderboard/AdSlotAnchorLeaderboard.selectors';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import useEventCallback from 'mk2/hooks/useEventCallback';
import { AnchorLeaderboardProps } from 'mk2/pages/Page';
import { AppState } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styles from './AdSlotAnchorLeaderboard.mscss';

export const PREFIX_AD_SLOT_ANCHOR_LEADERBOARD = 'mk-stickyrectangle';

export const SHOW_DELAY = 2000;  // 2 seconds delay

export interface OwnProps extends AnchorLeaderboardProps {
    requestUser: UserEntity;
    location: Location;
}


interface StateProps {
    // render elements of AdSlotAnchorLeaderboard if adSlotRenderEnded is true
    adSlotRenderEnded: boolean;
    adSlotClosedByUser: boolean;

}

interface DispatchProps {
    onAdSlotAnchorLeaderboardCloseByUser(closed: boolean);
}

type Props = OwnProps & StateProps & DispatchProps;

const AdSlotAnchorLeaderboard: React.FC<Props> = ({
    adSlotRenderEnded,
    adSlotClosedByUser,
    zone,
    targeting,
    location,
    requestUser,
    onAdSlotAnchorLeaderboardCloseByUser,
}) => {
    // const [isClosedByUser, setIsClosedByUser] = useState(false);
    const [timeoutExpired, setTimeoutExpired] = useState(false);

    const onAdSlotAnchorLeaderboardCloseByUserCallback = useEventCallback((closed: boolean) => {
        onAdSlotAnchorLeaderboardCloseByUser(closed);
    }, []);


    useEffect(() => {
        onAdSlotAnchorLeaderboardCloseByUserCallback(false);
        setTimeoutExpired(false);

        const timer = setTimeout(() => {
            setTimeoutExpired(true);
        }, SHOW_DELAY);

        return () => clearTimeout(timer);
    }, [zone, location?.key]);

    const handleClose = () => {
        onAdSlotAnchorLeaderboardCloseByUserCallback(true);
    };

    if (adSlotClosedByUser || !timeoutExpired || !hasAds(requestUser)) {
        return null;
    }

    return (
            <div className={cx(
                styles.AdSlotAnchorLeaderboard,
                adSlotRenderEnded && styles['AdSlotAnchorLeaderboard--rendered'],
            )}>
            {adSlotRenderEnded && (
                <div className={styles.AdSlotAnchorLeaderboard__tabs}>
                    <div
                        className={styles.AdSlotAnchorLeaderboard__tabs__tab}
                        onClick={handleClose}
                    >
                        {CLOSE_STICKY_RECTANGLE}
                    </div>
                </div>
            )}
            <div className={cx(
                styles.AdSlotAnchorLeaderboard__ad,
                adSlotRenderEnded && styles['AdSlotAnchorLeaderboard__ad--rendered'],
            )}>
                <AdSlot
                    zone={zone}
                    prefix={PREFIX_AD_SLOT_ANCHOR_LEADERBOARD}
                    targeting={targeting}
                    location={location}
                />
            </div>
        </div>
    );
};

function mapStateToProps(state: AppState, _ownProps: OwnProps): StateProps {
    const substate = getAdSlotAnchorLeaderboardState(state);
    return {
        adSlotRenderEnded: substate.adSlotRenderEnded,
        adSlotClosedByUser: substate.adSlotClosedByUser,
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onAdSlotAnchorLeaderboardCloseByUser: adSlotAnchorLeaderboardCloseByUser,
};



export default connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps,
)(AdSlotAnchorLeaderboard);

